import { makeChargerEventsState } from './helper';
import { sortDescByKey } from './actions';

const defaultState = {
  logsEventsArray: [],
  lastEventTs: null,
  newPlazaLogs: [],
  chargerEvents: {},
  initialValues: {
    chargerUuids: [],
    eventTypes: [],
  },
  isSubmitted: false,
};

function logEvents(state = defaultState, action) {
  switch (action.type) {
    case 'CLEAR_STATE':
      return defaultState;
    case 'CLEAR_LOGS_STATE':
      return defaultState;
    case 'CLEAR_LOGS':
      return { ...state, logsEventsArray: [] };
    case 'INIT_LOGS_BASE':
      return {
        ...state,
        createdAt: action.createdAt,
        logsEventsArray: action.logsArray,
        newPlazaLogs: [],
      };
    case 'INIT_NEW_LOGS': {
      const logs = [...state.newPlazaLogs, ...state.logsEventsArray];
      const sortedData = sortDescByKey(logs, 'ts');

      return {
        ...state,
        createdAt: action.createdAt,
        logsEventsArray: sortedData,
        newPlazaLogs: [...action.logsArray],
        chargerEvents: makeChargerEventsState(action.logsArray, state.chargerEvents),
      };
    }
    case 'SLICE_FIRST_CHARGER_EVENT': {
      const chargerEvents = state.chargerEvents[action.payload];

      if (chargerEvents) {
        return {
          ...state,
          chargerEvents: {
            ...state.chargerEvents,
            [action.payload]: chargerEvents.slice(1),
          },
        };
      }

      return state;
    }
    case 'CLEAR_NEW_LOGS': {
      if (state.newPlazaLogs.length === 0) {
        return state;
      }

      const logs = [...state.newPlazaLogs, ...state.logsEventsArray];
      const sortedData = sortDescByKey(logs, 'ts');

      return {
        ...state,
        logsEventsArray: sortedData,
        newPlazaLogs: [],
      };
    }

    case 'SET_INITIAL_VALUES': {
      return {
        ...state,
        initialValues: {
          ...state.initialValues,
          ...action.payload,
        },
      };
    }

    case 'SET_IS_SUBMITTED': {
      return {
        ...state,
        isSubmitted: action.payload,
      };
    }

    default:
      return state;
  }
}

export default logEvents;
